export default __webpack_public_path__ + "static/media/survey.62f29549.png";